let $ = require('jquery');
let Backbone = require("backbone");

let main = function () {
    var MobileOrderModalView = Backbone.View.extend({
        el: "#mobileOrderModal",
        events: {
            'click .createQrcode': '_createQrcode'
        },
        _createQrcode: function () {
            var self = this, jxhr;
            $(".qrCodeStaff").attr("src", "").addClass("hidden");
            jxhr = $.post("/pos/staffLoginQrCode", {staffid: $(".chooseStaff").val()});
            jxhr.done(function (response) {
                if (response.success) {
                    $(".qrCodeStaff").attr("src", response.url).removeClass("hidden");
                }
            });
            jxhr.fail(function (response) {

            });
        },
        show: function () {
            this.$el.modal("show");
            $(".qrCodeStaff").attr("src", "").addClass("hidden");
        },
        hide: function () {
            this.$el.modal("hide");
        }
    });

    return MobileOrderModalView;
};

let exportedValue = main();
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/view/MobileOrderModalView.js